module.exports = __webpack_public_path__ + "static/media/Ahmed_Nazir_Resume_2.471baabd.pdf";